import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4989b07e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4989b07e')) {
      api.createRecord('4989b07e', component.options)
    } else {
      api.reload('4989b07e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4989b07e&", function () {
      api.rerender('4989b07e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notice/record/index.vue"
export default component.exports